module.exports = __webpack_public_path__ + "img/agpz-train-selected.6c2d14b8.svg";